import { Directive, inject, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { WizardComponent } from 'mbs-ui-kit';
import { HelpService } from 'mbs-ui-shared@help/help.service';
import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { WizardHelpLink, WizardHelpLinkHook } from 'wizards/remote-management-wizards/strategy/wizard-help-link.class';
import { WizardStepsManagerClass, WizardStepsManagerHook } from 'wizards/remote-management-wizards/strategy/wizard-steps-manager.class';
import { WizardStepsService } from 'wizards/services/wizard-steps.service';

@UntilDestroy()
@Directive()
export abstract class SimpleWizardBaseClass implements WizardHelpLinkHook, WizardStepsManagerHook, OnInit {
  public ability = inject(AbilityService);
  public i18nPipe = inject(I18NextPipe);
  protected stepService = inject(WizardStepsService);
  protected helpService = inject(HelpService);

  public abstract FormModel: any;
  public planType: PlanTypes;
  public helpLink: WizardHelpLink<string> = new WizardHelpLink(this.helpService, this);
  public stepsManager = new WizardStepsManagerClass(this.i18nPipe, this.stepService, this);

  @ViewChild(WizardComponent, { static: true }) wizard: WizardComponent;

  constructor() {
    this.stepService.reset();
  }

  ngOnInit() {
    this.helpLink.initHelpDocumentationLinks();
  }

  forceValidStep(name: string): void {}
}
